<script setup lang="ts">
/*
  테이블 데이터가 없을 때 테이블 바디에 커스텀 컴포넌트 넣어주는 컴포넌트
  기존에 있는 No Data 영역 제거하고 slot 을 통해 커스텀 element 를 추가한다
  타겟이 될 테이블 클래스명은 필요
  */
import { setup, type Props } from './noDataTableBody.setup';

const props = withDefaults(defineProps<Props>(), {
  targetElement: '.modern-grid-body-area',
});

const { showContent, teleportTo, teleportContentId } = setup(props);
</script>

<template>
  <teleport
    v-if="showContent"
    :to="teleportTo"
  >
    <div
      class="no-data-container"
      :data-no-data-table-body-id="teleportContentId"
    >
      <slot />
    </div>
  </teleport>
</template>

<style scoped lang="scss">
.no-data-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  &__area {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    padding: 16px;
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__desc {
      font-size: 14px;
    }
  }
}
</style>
